import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
export class TermFees {
    _termNumber;
    _humanTermNumber;
    jsTermNumber;
    jsHumanTermNumber;
    _fees;
    constructor(params) {
        this.termNumber = params.termNumber;
        this.fees = params.fees;
    }
    get termNumber() {
        return this._termNumber;
    }
    set termNumber(value) {
        this._termNumber = value;
        this.jsTermNumber = value;
        this._humanTermNumber = value + 1;
        this.jsHumanTermNumber = this._humanTermNumber;
    }
    set humanTermNumber(value) {
        this._termNumber = value - 1;
        this.jsTermNumber = this._termNumber;
        this._humanTermNumber = value;
        this.jsHumanTermNumber = this._humanTermNumber;
    }
    get humanTermNumber() {
        return this._humanTermNumber;
    }
    get fees() {
        return this._fees;
    }
    set fees(value) {
        this._fees = value;
    }
    get json() {
        return {
            termNumber: this.jsTermNumber,
            humanTermNumber: this.humanTermNumber,
            fees: this.fees.map((fee) => fee.json),
        };
    }
    addFee(fee) {
        this.fees.push(fee);
    }
    removeFeeById(id) {
        this.fees = this.fees.filter((fee) => fee.id !== id);
    }
    getFeeById(id) {
        return this.fees.find((fee) => fee.id === id);
    }
    syncJsToValues() {
        this.humanTermNumber = this.jsHumanTermNumber;
    }
    // returns flatten array of term fees
    get flatTermFees() {
        return this.fees.map((fee) => {
            return {
                termNumber: this.termNumber,
                fee: fee,
            };
        });
    }
}
